<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">{{ $t("home") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'exam' }">{{ $t("exam") }}</router-link>
          <span>></span>
          <router-link :to="{ name: 'enroll', params: { id: plan_id } }">{{ topTitle }}</router-link>
          <span>></span>
          <span>{{ "在线考试" }}</span>
        </div>
        <xiCheck
          ref="xiCheck"
          v-if="questionList.length > 0"
          @confrimAll="confrimAll"
          @checkOption="checkOption"
          :questionList="questionList"
          :timestamp="timestamp"
        ></xiCheck>
      </div>
    </div>
  </div>
</template>

<script>
import xiCheck from "@/components/xi-check/xi-check.vue";
export default {
  components: { xiCheck },
  data() {
    return {
      topTitle: "详情",
      order_id: "",
      plan_id: "",
      questionList: [],
      passScore: "",
      timestamp: 0,
      make_up_exam: "",
      leave: {
        isModalShow: false, // 是否显示离开弹窗
        allow: false, // 是否允许离开
        to: "", // 要跳转的路由
      },
      autoPush: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    this.leave.to = to.path; // 记录要跳转的路由
    // 判断是否可以离开
    if (this.leave.allow) {
      next(true);
    } else {
      this.leave.isModalShow = true; // 显示离开弹窗
      this.$refs.xiCheck.confirmSubmission = true;
      next(false);
    }
  },

  mounted() {
    // console.log(this.$route);
    this.topTitle = this.$route.params.title;
    sessionStorage.setItem("examTitle", this.topTitle);
    this.order_id = this.$route.params.order_id;
    this.plan_id = this.$route.params.plan_id;
    this.init(this.$route.params.plan_id);
  },
  methods: {
    init(data) {
      this.$api.examinaTopicList({ plan_id: data }).then((res) => {
        if (res.status) {
          this.questionList = res.data.list;
          this.plan_id = res.data.info.id;
          this.passScore = res.data.pass_score;
          this.make_up_exam = res.data.info.make_up_exam;
          this.timestamp = res.data.info.times * 60;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    // 提交事件
    confrimAll(e) {
      // console.log("提交", e.checkRes);
      var tr = e.checkRes;
      if (this.passScore > tr.all_score) {
        this.isPass = 0;
      } else {
        this.isPass = 1;
      }
      var data = {
        plan_id: this.plan_id,
        param: tr.keyFormat,
        status: 2,
        make_up_exam: this.make_up_exam,
        exam_timetype_id: tr.times,
        correct_quantity: tr.correct_quantity,
        errors_quantity: tr.errors_quantity,
        order_id: this.order_id,
        is_pass: this.isPass,
        total_score: tr.all_score,
      };
      var datas = {
        id: this.plan_id,
        order_id: this.order_id,
        correct_quantity: tr.correct_quantity,
        errors_quantity: tr.errors_quantity,
        tika: tr.tika,
        allTime: tr.times,
        scareNumber: tr.all_score,
        is_pass: this.isPass, //0：未通过，1：通过
      };

      this.$api.questionSubmit(data).then((res) => {
        if (res.status) {
          localStorage.removeItem(`startExam_${this.plan_id}`);
          datas.make_up_exam = res.data.make_up_exam;
          datas.class_id = res.data.id;
          this.leave.allow = true;
          // this.$router.push({
          //   name: "viewReport",
          //   params: {
          //     datas: JSON.stringify(datas),
          //   },
          // });
          localStorage.setItem("exercise", JSON.stringify(datas));
          const { href } = this.$router.resolve({
            name: "viewReport",
            params: {
              datas: "no",
            },
          });
          if (!this.autoPush) {
            window.open(href, "_blank");
            window.close();
          } else {
            var form = document.createElement("form");
            form.action = href;
            form.target = "";
            form.method = "";
            document.body.appendChild(form);
            form.submit();
          }
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // 答案选择 change 事件
    checkOption(e) {
      // console.log('check', e);
      // 跳页面
    },
    // 提示确认
    confirmSub() {
      this.$refs.xiCheck.comeBack();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.class-item-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .class-item {
    width: 296px;
    height: 200px;
    margin-top: 20px;
    margin-bottom: 30px;
    margin-left: 13px;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &:hover {
      box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1);
    }
    // &:first-child {
    //   margin-left: 0;
    // }
    &:nth-child(4n + 1) {
      margin-left: 0;
    }
    .videp-cover {
      width: 296px;
      height: 200px;
    }
    .title {
      position: absolute;
      bottom: 0%;
      left: 0%;
      width: 100%;
      height: 50px;
      background: rgba(49, 44, 44, 0.5);
      text-align: center;
      line-height: 50px;
      color: white;
      font-size: 14px;
    }
  }
}
.exam-box {
  width: 100%;
  height: auto;
  padding: 52px 20px 40px;
  background-color: white;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .text_prc {
    width: 100%;
    // height: 22px;
    line-height: 22px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .text_prc_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: left;
      .text_prc_left_title {
        margin-bottom: 32px;
        height: 22px;
        padding-left: 100px;
      }
    }
  }
}
.class-list {
  // background: #ffffff;
  width: 1226px;
  margin: 20px auto 0;
  // padding: 30px;
  margin-bottom: 20px;
  box-sizing: border-box;
}
.class-title {
  color: #333333;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    display: inline-block;
    width: 6px;
    height: 38px;
    background: #ff6d6d;
    border-radius: 4px;
    margin-right: 7px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
  }
}
.tr-foot {
  display: flex;
  // position: absolute;
  justify-content: center;
  margin-bottom: 40px;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
    &.disabled {
      background-color: rgb(245, 127, 112);
    }
  }
  .collete-btn {
    min-width: 45px;
    height: 47px;
    text-align: center;
    // padding-top: 5px;
    padding: 5px 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
</style>
